import { trackById } from 'src/app/shared/utils/track-by.util';
import { Component, OnInit, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { ToastService } from 'src/app/services/toast.service';
import { forkJoin } from 'rxjs';
import { UserUpdateModel } from 'src/app/models/userUpdateModel';
import { Enum } from 'src/app/models/enum.model';
import { SecurityProfileEnum } from 'src/app/enums/securityProfile.enum';

export interface EditUserDialogData {
    id: string;
}

@Component({
  standalone: false,
    selector: 'app-edit-user-dialog',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: 'editUserDialog.component.html',
})
export class EditUserDialogComponent implements OnInit, OnDestroy {

    isFormLoading = false;
    isLoading = false;
    securityProfiles: Enum[];
    user: UserUpdateModel;
    isNoneUser = false;

    constructor(public dialogRef: MatDialogRef<EditUserDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EditUserDialogData,
        private userService: UserService,
        private toastService: ToastService) {

        this.securityProfiles = [];
        this.user = new UserUpdateModel();
    }

    ngOnInit() {
        this.isFormLoading = true;
        forkJoin({
            user: this.userService.getById(this.data.id),
            securityProfiles: this.userService.getSecurityProfileLookupList()
        }).subscribe(
            result => {
                this.user = result.user;
                this.isNoneUser = this.user.securityProfileId === undefined || this.user.securityProfileId === SecurityProfileEnum.None;
                this.securityProfiles = result.securityProfiles;
                this.isFormLoading = false;
            },
            error => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            }
        );
    }

    save() {
        this.isLoading = true;
        this.userService.update(this.user)
            .subscribe(
                response => {
                    this.toastService.showSuccess('User saved successfully', true);
                    this.isLoading = false;
                    this.dialogRef.close(true);
                },
                error => {
                    this.isLoading = false;
                    this.toastService.showErrors(error, ['Id', 'FullName', 'SecurityProfileId']);
                }
            );
    }

    public trackById = trackById;

    ngOnDestroy() {
    }
}
